export const environment = {
	production: true,
	baseUrl: 'https://premio.iel.org.br/api-premio-iel-talentos/',
	nome: 'ambiente',
};
